import { type JSX, type ReactNode } from "react";

import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { type SxProps } from "@mui/material";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";

type Props = {
  title: ReactNode;
  subheader?: ReactNode;
  backButtonRoute?: string;
  action?: JSX.Element;
  children?: JSX.Element;
  sxProps?: SxProps;
};

export const PageHeader = ({ title, subheader, action, children, backButtonRoute, sxProps }: Props) => (
  <>
    <CardHeader
      sx={{ width: "100%", ...sxProps }}
      title={title}
      subheader={subheader}
      slotProps={{
        title: { variant: "h1" },
        subheader: { variant: "body2" },
      }}
      avatar={
        backButtonRoute ? (
          <IconButton component={Link} to={backButtonRoute} data-cy="page-header-back-button" size="large">
            <ArrowBackIcon />
          </IconButton>
        ) : undefined
      }
      action={action}
    />
    {children}
  </>
);
